import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import toast from "react-hot-toast";
import { Save, ArrowLeft, Loader2 } from "lucide-react";

export default function AddFaqPage() {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    sortOrder: 1,
    questionTr: "", questionEn: "", questionAr: "",
    answerTr: "", answerEn: "", answerAr: "",
  });

  useEffect(() => {
    api.get("/setting")
      .then((res) => setSettings(res.data))
      .catch(() => toast.error("Ayarlar yüklenemedi"))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/faq", formData);
      toast.success("SSS eklendi");
      navigate("/faq-list");
    } catch { toast.error("SSS eklenirken hata oluştu"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="page-loading"><div className="loading-spinner" /><p>Yükleniyor...</p></div>;
  if (!settings) return <div className="page-loading"><p>Ayarlar bulunamadı.</p></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Yeni SSS Ekle</h2>
          <p className="page-subtitle">Sıkça sorulan sorulara yeni kayıt ekleyin</p>
        </div>
        <button className="btn btn-ghost" onClick={() => navigate("/faq-list")}>
          <ArrowLeft size={18} /> Listeye Dön
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="content-card" style={{ maxWidth: 800 }}>
          <div className="form-field">
            <label>Sıra Numarası</label>
            <input type="number" name="sortOrder" value={formData.sortOrder} onChange={handleChange} className="form-input" min={1} style={{ maxWidth: 120 }} />
          </div>

          {settings.turkish && (
            <div className="lang-section">
              <h3 className="card-title">🇹🇷 Türkçe</h3>
              <div className="form-field">
                <label>Soru</label>
                <input type="text" name="questionTr" value={formData.questionTr} onChange={handleChange} className="form-input" placeholder="Soru giriniz" />
              </div>
              <div className="form-field">
                <label>Cevap</label>
                <textarea name="answerTr" value={formData.answerTr} onChange={handleChange} className="form-input" rows={4} placeholder="Cevap giriniz" />
              </div>
            </div>
          )}

          {settings.english && (
            <div className="lang-section">
              <h3 className="card-title">🇬🇧 English</h3>
              <div className="form-field">
                <label>Question</label>
                <input type="text" name="questionEn" value={formData.questionEn} onChange={handleChange} className="form-input" placeholder="Enter question" />
              </div>
              <div className="form-field">
                <label>Answer</label>
                <textarea name="answerEn" value={formData.answerEn} onChange={handleChange} className="form-input" rows={4} placeholder="Enter answer" />
              </div>
            </div>
          )}

          {settings.arabic && (
            <div className="lang-section">
              <h3 className="card-title">🇸🇦 العربية</h3>
              <div className="form-field">
                <label>السؤال</label>
                <input type="text" name="questionAr" value={formData.questionAr} onChange={handleChange} className="form-input" placeholder="أدخل السؤال" dir="rtl" />
              </div>
              <div className="form-field">
                <label>الجواب</label>
                <textarea name="answerAr" value={formData.answerAr} onChange={handleChange} className="form-input" rows={4} placeholder="أدخل الجواب" dir="rtl" />
              </div>
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate("/faq-list")}>İptal</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <><Loader2 size={18} className="spin" /> Kaydediliyor...</> : <><Save size={18} /> Kaydet</>}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
